import { observer } from 'mobx-react-lite';
import type { PropsWithChildren } from 'react';

import { Tooltip } from '../tooltip';

type Props = PropsWithChildren<{
  text?: string | null;
  visible?: boolean;
}>;

export const FormTooltip = observer<Props>(function FormTooltip({ children, text, visible = true }) {
  return (
    <Tooltip text={text ?? ''} placement="left" visible={text && visible ? undefined : false}>
      <div>{children}</div>
    </Tooltip>
  );
});
